
import $ from 'jquery';

import VariantHelper from '../utils/VariantHelper';
import ProductGallery from '../components/ProductGallery';

export default class ProductDetails {
  constructor(instance) {
    this.$el = $(instance.el);

    this.el = instance.el;
    this.data = instance.data;

    this.$productForm = $('[data-product-form]', this.$el);
    this.formID = this.$productForm.attr('data-product-form');
    this.processing = false;

    // Form selectors
    this.productForm = `product-form-${this.formID}`;
    this.$addToCartButton = $('.add-to-cart input', this.$el);
    this.$priceArea = $('.product-price', this.$el);
    this.$productMessage = $('[data-product-message]', this.$el);

    // Setup product information
    const $productJSON = $(`[data-product-json-${this.formID}]`, this.$el);
    const $productSettings = $(`[data-product-settings-${this.formID}]`, this.$el);

    if (!$productJSON.length) { return; }

    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());
    this.$variantDropdowns = $(`[data-option-select=${this.formID}]`, this.$el);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;

    this.productGallery = new ProductGallery(
      this.el.querySelector('[data-product-gallery]'),
      {
        enable_video_autoplay: this.data.settings.gallery_enable_video_autoplay,
        enable_video_looping: this.data.settings.gallery_enable_video_looping,
        enable_zoom: this.data.settings.gallery_enable_zoom,
      },
    );

    this.$el
      .on('submit', '.product-form', event => this.addToCart(event))
      .on('click', '.product-tabs-header-item', event => this.tabs(event))
      .on('click', '.number-input-nav-item', event => this.amount(event));

    if (this.$variantDropdowns.length) {
      this.setupVariants();
    }

    // Watchers / Bound Events
    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
  }

  prepareRemove() {
    this.unload();
    if (this.variantHelpers) {
      this.variantHelpers.prepareRemove();
    }
  }

  setupVariants() {
    const dropdownSettings = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $selector: this.$variantDropdowns,
      formID: this.formID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
      type: 'select',
      productGallery: this.productGallery
    };

    this.variantHelpers = new VariantHelper(dropdownSettings);
  }

  addToCart(e) {
    if (this.productSettings.cartRedirect) { return; }

    e.preventDefault();

    if (this.processing) { return; }
    this.processing = true;

    this.$el.find('.add-to-cart').addClass('loading');

    const quantity = this.$el.find("input[name='quantity']").val();

    if ((quantity === '') || (quantity === '0')) {
      setTimeout(() => {
        this.$el.find("input[name='quantity']")
          .addClass('error');
        this.$productMessage
          .text(this.productSettings.setQuantityText);
        this.$el.find('.add-to-cart')
          .removeClass('loading added-success')
          .addClass('added-error');
        this.processing = false;
      },
      500);
    } else {
      Shopify.addItemFromForm(this.productForm, cartItem => setTimeout(() => {
        Shopify.getCart(cart => $('.cart-link .cart-count').text(cart.item_count));

        const successMessage = this.productSettings.successMessage.replace('** product **', `<em>${cartItem.title}</em>`);

        this.$productMessage.html(successMessage);
        this.$el.find("input[name='quantity']")
          .removeClass('error');
        this.$el.find('.add-to-cart')
          .removeClass('loading added-error')
          .addClass('added-success');
        $('.header-cart-count').addClass('active');

        this.$addToCartButton.val(this.productSettings.addToCartText);

        this.processing = false;
      },
      1000));
    }
  }

  handleErrors(errors) {
    const errorMessage = $.parseJSON(errors.responseText);
    const productTitle = this.productJSON.title;

    let errorDescription = errorMessage.description;
    if ((errorMessage.description ? errorMessage.description.indexOf(productTitle) : -1) > -1) {
      errorDescription = errorDescription.replace(productTitle, `<em>${productTitle}</em>`);
    }

    if (errorMessage.message === 'Cart Error') {
      setTimeout(() => {
        this.$el.find("input[name='quantity']").removeClass('error');
        this.$productMessage.html(errorDescription);
        this.$el.find('.add-to-cart').removeClass('loading added-success').addClass('added-error');

        this.$addToCartButton.val(this.productSettings.addToCartText);

        this.processing = false;
      },
      1000);
    }
  }

  tabs(e) {
    const target = $(e.currentTarget).attr('data-tab');
    const bodyTarget = $(e.currentTarget).parents('.product-tabs').find(`#${target}`);
    $(e.currentTarget).addClass('active').siblings().removeClass('active');
    return bodyTarget.addClass('active').siblings().removeClass('active');
  }

  amount(e) {
    const input = $(e.currentTarget).parents('.number-input-wrapper').find('input');
    const result = parseFloat(input.val());
    if ($(e.currentTarget).hasClass('icon-plus')) {
      input.val(result + 1);
    }
    if ($(e.currentTarget).hasClass('icon-minus') && result > 0) {
      input.val(result - 1);
    }
  }

  unload() {
    this.$el
      .off('submit', '.product-form')
      .off('click', '.product-tabs-header-item')
      .off('click', '.number-input-nav-item');

    this.productGallery.unload();
  }
}
